import fetch from '@/utils/fetch';

export function statisticsDat(params){

    return fetch({
         url:'WebSum/WebSum/selectDay',
         method:"post",
         data:params
    })

}

export function statisticsSum(params){

    return fetch({
         url:'WebSum/WebSum/sumSelectDay',
         method:"post",
         data:params
    })

}

export function historySum(params){

    return fetch({
         url:'WebSum/WebSum/sumTotalPlay',
         method:"post",
         data:params
    })

}

export function schoolList(params){

    return fetch({
         url:'WebSum/WebSum/getOrgList',
         method:"post",
         data:params
    })

}

export function seekRank(params){

    return fetch({
         url:'WebSum/WebSum/statisticsWordByOrganizationId',
         method:"post",
         data:params
    })

}



// WEBPACK FOOTER //
// ./src/api/statistics.js